import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import SearchPage from "../pages/search/page";
import DetailPage from "../pages/detail/page";
import NewsList from "../pages/news/page";
import NewsDetail from "../pages/newsDetail/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/:type", element: <CategoryPage /> },
      { path: "/search", element: <SearchPage /> },
      { path: "/detail/:id", element: <DetailPage /> },
      { path: "/news", element: <NewsList /> },
      { path: "/news/:id", element: <NewsDetail /> },
      { path: "/about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;